<template>

</template>

<script>
    import {dateShortCuts, defaultDateRange} from "../../helpers/date-converter";

    export default {
        name: 'action-header',
        props: ['headerTitle'],
        data: function () {
            return {
                time: defaultDateRange(),
                shortcuts: dateShortCuts(),
            }
        },
        mounted() {
        }
    }
</script>
